import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';

export const withClipchampPlayer = (WrappedComponent) => {
  const Wrapper = (props) => {
    const loadClipchampPlayer = async () => {
      const [
        { createAssetResolver },
        {
          Player,
          usePlayPause,
          usePlayerControls,
          usePlayerTime,
          useFormattedTimeAndDuration,
        },
        { UrlAssetFetchHandler },
        { createHubbleAssetFetchHandler },
        { populateSystemAssets },
      ] = await Promise.all([
        import('@clipchamp/asset-resolution'),
        import('@clipchamp/superfill-react'),
        import('@clipchamp/asset-resolution/providers/url'),
        import('@clipchamp/asset-resolution/providers/hubble'),
        import('@clipchamp/asset-resolution/unsafe_system-assets'),
      ]);

      return {
        createAssetResolver,
        Player,
        UrlAssetFetchHandler,
        createHubbleAssetFetchHandler,
        populateSystemAssets,
        usePlayPause,
        usePlayerControls,
        usePlayerTime,
        useFormattedTimeAndDuration,
      };
    };

    return (
      <WrappedComponent
        {...props}
        loadClipchampPlayer={loadClipchampPlayer}
      />
    );
  };

  Wrapper.displayName = `withClipchampPlayer(${getDisplayName(WrappedComponent)})`;

  hoistNonReactStatics(Wrapper, WrappedComponent);

  return Wrapper;
};
